'use client';

import { type AppRouter, type ClientArgs } from '@ts-rest/core';
import { initTsrReactQuery } from '@ts-rest/react-query/v5';
import Cookies from 'js-cookie';
import { AuthCookieName } from '../auth/auth-constant';
import { getBackendUrl } from './url';

const currentCookie = Cookies.get(AuthCookieName);

export const generateRestClient = <T extends AppRouter>(
  router: T,
  withHeaders: boolean = true
) => {
  return initTsrReactQuery(router, {
    baseUrl: getBackendUrl(),
    baseHeaders: withHeaders
      ? {
          authorization: currentCookie ? `Bearer ${currentCookie}` : '',
        }
      : undefined,
    jsonQuery: true,
  } as ClientArgs);
};
